import Vue from "vue";
import { BootstrapVue, IconsPlugin, TooltipPlugin } from "bootstrap-vue";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

import App from "./App.vue";
import router from "./router";

import Client from "./client";
import {
  saveAuthTokens,
  clearAuthTokens,
  retrieveAuthTokens,
  parseAuthTokens,
} from "./common/authentication_utils";

// Install BootstrapVue
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);

Vue.use(TooltipPlugin);

Vue.config.productionTip = false;

let user = {};

const { accessToken, idToken } = retrieveAuthTokens();
const { decodedAccessToken, decodedIdToken } = parseAuthTokens(
  accessToken,
  idToken
);

if (decodedIdToken) {
  user.name = decodedIdToken.name || "Missing Name";
  user.email = decodedIdToken.email || "MissingEmail@Fake.com";
  user.exp = Math.min(decodedIdToken.exp, decodedAccessToken.exp);
  user.accessToken = accessToken;

  saveAuthTokens(accessToken, idToken);
} else {
  clearAuthTokens();
}

Vue.prototype.$user = user;

const handleUnauthorized = () => {
  console.log("Redirecting to login page after unauthorized response.");
  router.push({ name: "Login" });
};
Vue.prototype.$client = new Client(
  process.env.VUE_APP_API_URL,
  accessToken,
  handleUnauthorized
);

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
